module.exports = __webpack_public_path__ + "img/icon__sharp-add_circle_outline--dark-gray.24abd7f1.svg";